module.exports = __webpack_public_path__ + "img/inc-indent.4acd4dc3.svg";